import { isUiModeProductAdmin } from "../../uiMode";
import { isDevelopmentEnvironment } from "../../estada-config";
import { noItx } from "../../translationItx/itx";

export default class TableInfo {
  id = "";
  instanceId = "";
  isGrid: boolean;
  isInline: boolean;

  rows = new Array<any>();
  columns = new Array<{ text: string; width: string | number | undefined }>();
  cells: any[][] = [[]];
  cellDatas: any[][] = [[]];

  collapseEmptyRows = true;

  constructor(id: string, instanceId: string, isGrid: boolean, isInline: boolean) {
    this.id = id;
    this.instanceId = instanceId;
    this.isGrid = isGrid;
    this.isInline = isInline;
  }

  render(): any {
    const colElements: any = [];
    const headElements: any = [];

    const renderRowHeader = this.rows.some((r) => r.text);

    if (renderRowHeader) {
      colElements.push(<col style={{ width: "auto" }} />);
      headElements.push(<th></th>);
    }

    // colElements.push(<col style={{ width: "auto" }} />);

    const hasHeader = this.columns.some((c) => c.text);

    const wTable = 730;

    this.columns.forEach((column) => {
      let w = column.width;
      if (!w) {
        w = "auto";
      } else if (typeof w == "string") {
        if (!w.endsWith("%")) {
          w = w + "px";
        } else {
          const wAbsolute = (parseFloat(w.replace("%", "").replace(",", ".")) / 100) * wTable;
          w = wAbsolute + "px";
        }
      }

      colElements.push(<col style={{ width: w }} />);
      headElements.push(<th>{column.text}</th>);
    });

    const rowElements: any = [];

    this.rows.forEach((row, rowIndex) => {
      rowIndex = rowIndex + 1; // rows are numbered starting from "1" ApplicationProgramms

      //      const rowHasContent = renderRowHeader || this.cells[rowIndex]?.some((cell: any) => cell);
      const rowHasContent = this.cells[rowIndex]?.some((cell: any) => cell);
      if (!this.collapseEmptyRows || rowHasContent) {
        const columnElements: any = [];
        if (renderRowHeader) {
          columnElements.push(
            <td className="rowHeader">
              <div>{row.text}</div>
            </td>,
          );
        }

        if (this.cells[rowIndex]) {
          for (let c = 1; c <= this.columns.length; c++) {
            const cell = this.cells[rowIndex][c];
            columnElements.push(<td>{cell}</td>);
          }
        }
        rowElements.push(<tr>{columnElements}</tr>);
      }
    });

    const showCellBorders = this.isInline && !this.isGrid;

    const fixed = !isUiModeProductAdmin() ? "fixed" : "initial"; // no itx
    return (
      <table
        className={`knxTable ${showCellBorders ? "showCellBorders" : ""}`}
        key={`table-${this.id}`}
        style={{
          tableLayout: renderRowHeader ? "inherit" : fixed,
          width: renderRowHeader ? "850px" : undefined,
        }}
        {...(isDevelopmentEnvironment() ? { "data-id": this.id, "data-instance-id": this.instanceId } : {})}
      >
        <colgroup>{colElements}</colgroup>
        <thead>
          {isUiModeProductAdmin() && (
            <tr>
              <td colSpan={10}>
                {noItx("Table id:")} {this.id} {noItx("InstanceId:")} {this.instanceId}
              </td>
            </tr>
          )}
          {hasHeader && <tr>{headElements}</tr>}
        </thead>
        <tbody>{rowElements}</tbody>
      </table>
    );
  }
}
